<template>
  <div class="stadium-page">
    <div class="club-page">
      <div class="video-frame">
        <iframe width="100%"
                src="https://www.youtube.com/embed/tvHmEW-DS24?si=7ZPBBpFuDkW2BKlS"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen>

        </iframe>
      </div>

      <section>
        <p class="title">드래곤던전 경기장 소개</p>
        <div class="img-content">
          <img src="@/assets/img/club/stadium.png" alt="stadium">
          <div>
            <p>
              광양축구전용구장은 전라남도 광양시 금호동
              포스코 광양제철소 내에 위치한 관중석 10,073석
              규모의 축구전용구장으로, 1993년 대한민국에서 두
              번째로 개장한 축구전용구장이다.
            </p>
            <br>
            <p>
              1992년 1월 착공하여 1992년 9월 완공 이후
              1994년 12월 16일 전남 드래곤즈가 창단되어
              K리그에 참여하면서, 1995년 3월 아디다스 컵부터
              전남 드래곤즈의 홈구장으로 사용되고 있다.
            </p>
            <p class="mobile">남쪽 관중석 뒤에 천연색 전광판 1개를 갖추고 있으며, 원폴형 조명타워가 설치되어 있다.</p>
          </div>
        </div>
        <p class="pc">남쪽 관중석 뒤에 천연색 전광판 1개를 갖추고 있으며, 원폴형 조명타워가 설치되어 있다.</p>
      </section>

      <section>
        <p class="title">경기장 위치정보</p>
        <ul v-for="(item, index) in locationInfo" :key="index" class="item">
          <li>
            <div class="icon">
              <img :src="imageSrc(item.icon)" alt="">
            </div>
          </li>
          <li>
            <p class="title">{{item.title}}</p>
            <div v-for="(children, index) in item.children" :key="index" class="children">
              <p class="sub">{{children.sub}}</p>
              <p class="desc">{{children.desc}}</p>
            </div>
          </li>
        </ul>
      </section>

      <section>
        <p class="title">경기장 위치</p>

      </section>
    </div>
    <!-- 카카오 이미지 지도 -->
    <KakaoMap class="map-div" />
  </div>
</template>

<script>
import KakaoMap from '@/components/Common/KakaoMap.vue';

export default {
  name: 'Stadium',
  components: {KakaoMap},
  data() {
    return {
      address: '전남광주통합특별시 광양시 백운로 1641',
      locationInfo: [
        {
          title: 'address',
          icon: 'location_pin',
          children: [
            {
              sub: '전남광주통합특별시 광양시 백운로 1641 (우편번호 57807)',
              desc: '1641, Baegun-ro, Gwangyang-si, Jeonnam-Gwangju, Republic of Korea (POSTCODE 57807)'
            }
          ]
        }, {
          title: 'bus stop',
          icon: 'bus',
          children: [
            {
              sub: '제철운동장 / 제1정문',
              desc: '88번 버스(광양교통, 광영고, 용지), 88번 버스(조선옥, 용지), 11-1(매화아파트.궁기)'
            }, {
              sub: '금당쇼핑',
              desc: '10번 버스(광양교통.창덕A.우림A.백운쇼핑), 10번 버스(매화A-창덕A-우림A-백운쇼핑), 86번 버스(옥곡정류장-궁기)'
            }
          ]
        }
      ]
    }
  },
  mounted () {
  },
  methods: {
    imageSrc(imgSrc) {
      return require('@/assets/img/icon/icon_'+imgSrc+'.png');
    }
  }
}
</script>
